import React, { useEffect, useRef, useState } from 'react';

export const CustomCursor = () => {
    const dotRef = useRef(null);
    const ringRef = useRef(null);
    const position = useRef({ x: 0, y: 0 });
    const ringPos = useRef({ x: 0, y: 0 });
    const [visible, setVisible] = useState(false);
    const [hovering, setHovering] = useState(false);

    useEffect(() => {
        const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        if (isTouchDevice) return;

        const handleMouseMove = (e) => {
            position.current = { x: e.clientX, y: e.clientY };
            if (!visible) setVisible(true);
        };

        const handleMouseOver = (e) => {
            const target = e.target;
            if (target.tagName === 'A' || target.tagName === 'BUTTON' ||
                target.closest('a') || target.closest('button')) {
                setHovering(true);
            }
        };

        const handleMouseOut = (e) => {
            const target = e.target;
            if (target.tagName === 'A' || target.tagName === 'BUTTON' ||
                target.closest('a') || target.closest('button')) {
                setHovering(false);
            }
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseover', handleMouseOver);
        document.addEventListener('mouseout', handleMouseOut);
        document.addEventListener('mouseleave', () => setVisible(false));
        document.addEventListener('mouseenter', () => setVisible(true));

        // Use RAF with refs - no setState on every frame
        let animId;
        const animate = () => {
            ringPos.current.x += (position.current.x - ringPos.current.x) * 0.15;
            ringPos.current.y += (position.current.y - ringPos.current.y) * 0.15;

            if (dotRef.current) {
                dotRef.current.style.transform = `translate(${position.current.x - 6}px, ${position.current.y - 6}px)`;
            }
            if (ringRef.current) {
                ringRef.current.style.transform = `translate(${ringPos.current.x - 20}px, ${ringPos.current.y - 20}px)`;
            }
            animId = requestAnimationFrame(animate);
        };
        animId = requestAnimationFrame(animate);

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseover', handleMouseOver);
            document.removeEventListener('mouseout', handleMouseOut);
            cancelAnimationFrame(animId);
        };
    }, []);

    if (!visible) return null;

    return (
        <>
            <div ref={dotRef} className="cursor-dot" style={{ willChange: 'transform' }} />
            <div ref={ringRef} className={`cursor-ring ${hovering ? 'scale-150 opacity-80' : 'opacity-40'}`} style={{ willChange: 'transform', transition: 'opacity 0.2s, scale 0.2s' }} />
        </>
    );
};
